<section class="bg-shl-light py-24 dark:bg-shl-dark">
  <div class="mx-auto max-w-3xl px-6 lg:px-8">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-black text-shl-navy dark:text-white">{{ 'faq.title' | translate }}</h2>
      <p class="mt-2 text-gray-500">{{ 'faq.subtitle' | translate }}</p>
    </div>
    <div class="space-y-4">
      @for (item of faqs; track item.question) {
        <details
          class="group rounded-xl bg-white p-6 shadow-sm [&_summary::-webkit-details-marker]:hidden dark:bg-shl-navy dark:shadow-none border border-gray-100 dark:border-gray-800"
        >
          <summary class="flex cursor-pointer items-center justify-between gap-1.5 text-shl-navy dark:text-white">
            <h3 class="text-lg font-bold">{{ item.question | translate }}</h3>
            <mat-icon
              fontSet="material-symbols-outlined"
              class="transition-transform duration-300 group-open:rotate-180"
            >
              expand_more
            </mat-icon>
          </summary>
          <div class="mt-4 leading-relaxed text-gray-600 dark:text-gray-300">
            {{ item.answer | translate }}
          </div>
        </details>
      }
    </div>
  </div>
</section>
